import { classNames } from "primereact/utils";

import { ScrollBar } from "../scroll-bar";
import styles from "./kanban.module.scss";
import type { KanbanViewProps } from "./types-kanban";

/**
 * Quadro: as colunas lado a lado numa área que rola na horizontal, com a nativa oculta (classe global) e a calha do DS
 * (`ScrollBar`) abaixo do quadro no desktop e sobre a base das colunas no mobile.
 */
export function KanbanView({
  device,
  bleedClassName,
  scrollerRef,
  testId,
  scrollBarTestId,
  className,
  style,
  rest,
  children,
}: KanbanViewProps) {
  return (
    <div
      className={classNames(styles.board, bleedClassName, className)}
      style={style}
      data-device={device}
      data-testid={testId}
      {...rest}
    >
      <div ref={scrollerRef} className={classNames(styles.scroller, "scrollbar-oculta")}>
        {children}
      </div>
      <ScrollBar.Root
        scrollerRef={scrollerRef}
        orientation="horizontal"
        className={styles.scrollBar}
        testId={scrollBarTestId}
      />
    </div>
  );
}
